import _ from '@/common/helpers';
import makeLinkComponent from '@/components/timeline/components/message-summary/make-link-component';

/**
 * Method for replacing string in string to array with components
 *
 * input ['abcdef'] - (message)
 * links [{placeholder: 'e'}, {placeholder: 'a'}, {placeholder: 'c'}]
 *
 * output [[A result], 'b', [C result], 'd', [E result], 'f']
 *
 * @param {array} message -  [message] array with 1 element message.
 * @param {array} links - message extradata links
 * @param {object} component - instance of message-summary component
 * @param {function} createElement - vue method
 * @param {function} isDisabledLink - check if resource link shouldn't render
 * @returns {array}
 */
const injectMessageLinks = ({
    message,
    links,
    component,
    createElement,
    isDisabledLink,
}) => links.reduce((memo, link) => memo.reduce((chunks, chunk) => {
    if (_.isObject(chunk)) {
        return [...chunks, chunk];
    }
    if (!chunk.includes(link.placeholder)) {
        return [...chunks, chunk];
    }
    const replaces = chunk.split(link.placeholder)
        .reduce((m, item, i) => ([
            ...m,
            ...i === 0 ? [] : [makeLinkComponent({
                component, createElement, link, isDisabledLink,
            })],
            item,
        ]), []);
    return [
        ...chunks,
        ...replaces,
    ];
}, []), message);

export default injectMessageLinks;
